module.exports = __webpack_public_path__ + "img/aws.4782276b.svg";